import { cn } from "@/lib/utils"
import LogoLand from "@/assets/logo-land.svg"
import { Stepper, StepperProps } from "../ui/stepper"
import { Card } from "../ui/card"
import { Button } from "../ui/button"
import { H2, H3, H4, P } from "../ui/typography"

type OnboardingLayoutProps = {
	children: React.ReactNode
	className?: string
	title: string
	description?: string
} & { stepper?: StepperProps } & OnboardingScreenProps &
	OnboardingNavigationProps

export function OnboardingLayout(props: OnboardingLayoutProps) {
	return (
		<div className="min-h-screen bg-gray-50 md:px-6 py-8">
			<div className={cn("container mx-auto", props.className)}>
				<PageHeader />
				<div className="w-[95%] sm:w-[80%] md:w-[60%] max-w-6xl mt-7 mx-auto">
					<Card className="relative p-6 flex flex-col gap-8">
						<div className="flex flex-col justify-between">
							<div>
								<div className="flex items-start justify-between">
									<H2 className="text-2xl md:text-3xl">{props.title}</H2>
									{props.stepper && (
										<div className="flex flex-row">
											<H3 className="font-normal">
												{props.stepper.currentStep}
											</H3>
											<H3 className="font-normal text-muted-foreground">
												/{props.stepper.steps}
											</H3>
										</div>
									)}
								</div>
								<P className="text-muted-foreground font-normal">
									{props.description}
								</P>
							</div>
							{props.stepper && (
								<div className="mt-6">
									<Stepper
										currentStep={props.stepper.currentStep}
										steps={props.stepper.steps}
									/>
								</div>
							)}
						</div>
						{props.children}
						<OnboardingNavigation
							onNext={props.onNext}
							onBack={props.onBack}
							continueText={props.continueText}
						/>
					</Card>
				</div>
			</div>
		</div>
	)
}

export type OnboardingScreenProps = {
	onBack?: () => void
	onNext?: () => void
}
type OnboardingNavigationProps = {
	continueText?: string
} & OnboardingScreenProps

export const OnboardingNavigation: React.FC<OnboardingNavigationProps> = (props) => {
	return (
		<div className={cn("flex", props.onBack ? "justify-between" : "justify-end")}>
			{props.onBack && (
				<Button
					onClick={props.onBack}
					size={"lg"}
					className="bg-secondary text-secondary-foreground"
				>
					Back
				</Button>
			)}

			{props.onNext && (
				<Button
					onClick={props.onNext}
					size={"lg"}
					className="text-primary-foreground"
				>
					{props.continueText || "Continue"}
				</Button>
			)}
		</div>
	)
}

export const PageHeader: React.FC = () => {
	return (
		<div className="flex items-center justify-between pb-6 border-b-slate-200 border-b-2">
			<div className="flex items-center gap-1.5 h-8">
				<img src={LogoLand} alt="Logo" className="h-full w-auto"></img>
				{/* <img
					src={MileKeeper}
					alt="MileKeeper"
					className="h-[14px] mt-[2px]"
				></img>
				<img src={AI} alt="AI" className="w-[14px] mb-[2px]" /> */}
			</div>
			<H4 className="text-base sm:text-xl text-right">Generate Mileage Reports with&nbsp;AI</H4>
		</div>
	)
}
